import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useAirlinesFilterController } from "./useAirlinesFilter.controller";
import AirlinesFilterItem from "./AirlinesFilterItem";
import { AirlinesFilterOptions } from "./AirlinesFilterOptions";
import { Button, Link, Stack } from "@bookingcom/bui-react";
import styles from "./Airlines.module.css";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export const AirlinesFilterMobile = () => {
  const {
    isFilterAvailable,
    title,
    showReset,
    resetLabel,
    onClickReset,
    options,
    value,
    onChange,
    optionsLimit,
    areOptionsTrucanted,
    optionsTogglerLabel,
    optionsTogglerIcon,
    onTogglerClick,
    selectAllTogglerLabel,
    deselectAllTogglerLabel,
    onSelectAll,
    isSelectAllDisabled,
    onDeselectAll,
    isDeselectAllDisabled
  } = useAirlinesFilterController();

  if (!isFilterAvailable) return null;

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  return (
    <FilterSection
      attributes={{ "data-testid": "airlines_filter" }}
      title={{
        text: title,
        tagName: "h3",
        attributes: { id: "airlines_filter" },
        variant: addNewFilters ? "strong_2" : "emphasized_1"
      }}
      reset={
        showReset && !addNewFilters
          ? { text: resetLabel, onClick: onClickReset, attributes: { "data-testid": "search_filter_airline_reset" } }
          : undefined
      }
    >
      <Stack direction="row" gap={4} mixin={{ paddingBlockEnd: 2 }}>
        {addNewFilters ? (
          <>
            <Button
              onClick={onSelectAll}
              disabled={isSelectAllDisabled}
              variant={"tertiary"}
              size={"large"}
              className={styles.button}
            >
              {selectAllTogglerLabel}
            </Button>
            <Button
              onClick={onDeselectAll}
              disabled={isDeselectAllDisabled}
              variant={"tertiary"}
              size={"large"}
              className={styles.button}
            >
              {deselectAllTogglerLabel}
            </Button>
          </>
        ) : (
          <>
            <Link onClick={onSelectAll} disabled={isSelectAllDisabled}>
              {selectAllTogglerLabel}
            </Link>
            <Link onClick={onDeselectAll} disabled={isDeselectAllDisabled}>
              {deselectAllTogglerLabel}
            </Link>
          </>
        )}
      </Stack>
      <AirlinesFilterOptions
        gap={4}
        togglerLabel={optionsTogglerLabel}
        togglerIcon={optionsTogglerIcon}
        onTogglerClick={onTogglerClick}
        options={options}
        optionsLimit={optionsLimit}
        areOptionsTrucanted={areOptionsTrucanted}
        renderOption={({ option, isHidden, index }) => (
          <AirlinesFilterItem
            key={`${index}-${option.value}`}
            value={option.value}
            label={option.label}
            count={option.count}
            checked={value.includes(option.value)}
            onChange={onChange}
            isHidden={isHidden}
          />
        )}
      />
    </FilterSection>
  );
};
